import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueCookies from 'vue-cookies'
import store from './store'
import httpRequest from '@/utils/httpRequest.js'
import httpsRequest from '@/utils/httpsRequest.js'
import track from '@/utils/track.js'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
// import '@/assets/theme/index.css'
// import * as echarts from 'echarts';
// import 'echarts-wordcloud';

Vue.prototype.$http = httpRequest;
Vue.prototype.$https = httpsRequest;
Vue.prototype.$track = track;
// Vue.prototype.$echarts = echarts;
Vue.config.productionTip = false;

Vue.config.silent = true;

Vue.use(VueCookies);
Vue.use(ElementUI);

// 路由导航过程中的权限认证
router.beforeEach((to, from, next) => {
	// debugger;
	let hascookie = document.cookie.indexOf('userinfo') > -1;
	if (to.meta.auth) {
		if (hascookie) {
			next()
		} else {
			alert("您未登录，请登录后查看！");
			VueCookies.set('unlogin','1');
			VueCookies.set('fromdetail',window.location.href);
			next('/');
		}
	} else {
		next()
	}
})

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
